import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import styles from './styles/global.module.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';

import Profile from './components/Profile';
import Experience from './components/Experience';
import AboutMe from './components/AboutMe';
import ContactInformation from './components/ContactInformation';
import WorkExperience from './components/WorkExperience';
import Services from './components/Services';
import CommercialDisclosure from './components/CommercialDisclosure';
import ThemeStyles from './components/ThemeStyles';

// Lazy load heavy components
const CodeEditorResumeApp = lazy(() => import('./codeEditorResume/CodeEditorResumeApp'));
const TerminalResumeApp = lazy(() => import('./terminalResume/TerminalResumeApp'));
const APIExplorerPage = lazy(() => import('./components/APIExplorerPage'));
const KanbanResumePage = lazy(() => import('./components/KanbanResumePage'));
const ChatbotResumeApp = lazy(() => import('./chatbotResume/ChatbotResumeApp'));
const SkillsSphereApp = lazy(() => import('./skillsSphere/SkillsSphereApp'));

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <ThemeStyles />
      <Router>
        <div className={styles.appContainer}>
          <Sidebar />
          <main id="main-content" className={styles.mainContent} tabIndex={-1}>
            <Header />
            <div className={styles.pageContent} role="region" aria-label="Page Content">
              <Switch>
                <Route path="/about-me" render={() => (
                  <div className={styles.pageTransition}>
                    <AboutMe />
                  </div>
                )} />
                <Route path="/experience" render={() => (
                  <div className={styles.pageTransition}>
                    <Experience />
                  </div>
                )} />
                <Route path="/contact-information" render={() => (
                  <div className={styles.pageTransition}>
                    <ContactInformation />
                  </div>
                )} />
                <Route path="/work-experience" render={() => (
                  <div className={styles.pageTransition}>
                    <WorkExperience />
                  </div>
                )} />
                <Route path="/services" render={() => (
                  <div className={styles.pageTransition}>
                    <Services />
                  </div>
                )} />              <Route path="/kanban-resume" render={() => (
                  <div className={styles.pageTransition}>
                    <Suspense fallback={<div className={styles.loadingSpinner}>Loading...</div>}>
                      <KanbanResumePage />
                    </Suspense>
                  </div>
                )} />
                <Route path="/code-editor-resume" render={() => (
                  <div className={styles.pageTransition}>
                    <Suspense fallback={<div className={styles.loadingSpinner}>Loading...</div>}>
                      <CodeEditorResumeApp />
                    </Suspense>
                  </div>
                )} />
                <Route path="/terminal-resume" render={() => (
                  <div className={styles.pageTransition}>
                    <Suspense fallback={<div className={styles.loadingSpinner}>Loading...</div>}>
                      <TerminalResumeApp />
                    </Suspense>
                  </div>
                )} />
                <Route path="/api-explorer" render={() => (
                  <div className={styles.pageTransition}>
                    <Suspense fallback={<div className={styles.loadingSpinner}>Loading...</div>}>
                      <APIExplorerPage />
                    </Suspense>
                  </div>
                )} />
                <Route path="/chatbot-resume" render={() => (
                  <div className={styles.pageTransition}>
                    <Suspense fallback={<div className={styles.loadingSpinner}>Loading...</div>}>
                      <ChatbotResumeApp />
                    </Suspense>
                  </div>
                )} />
                <Route path="/skills-sphere" render={() => (
                  <div className={styles.pageTransition}>
                    <Suspense fallback={<div className={styles.loadingSpinner}>Loading...</div>}>
                      <SkillsSphereApp />
                    </Suspense>
                  </div>
                )} />
                <Route path="/commercial-disclosure" render={() => (
                  <div className={styles.pageTransition}>
                    <CommercialDisclosure />
                  </div>
                )} />
                <Route path="/" render={() => (
                  <div className={styles.pageTransition}>
                    <Profile />
                  </div>
                )} />
              </Switch>
            </div>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;